export enum TaskState {
    Queued = "Queued",
    Executing = "Executing",
    Failed = "Failed",
    Canceled = "Canceled",
    TimedOut = "TimedOut",
    Success = "Success",
    Cancelling = "Cancelling",
}

export default TaskState;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/resources/taskState.ts